import { siteConfig } from "~/config/site"

const BADGE_REL = "ugc nofollow noopener"

type ToolBadgeEmbedTool = {
  name: string
  slug: string
}

type ToolBadgeEmbedOptions = {
  height: number
  theme: string
  width: number
}

export function getToolBadgeUrl(tool: ToolBadgeEmbedTool, options: ToolBadgeEmbedOptions): string {
  const params = new URLSearchParams({
    theme: options.theme,
    width: String(options.width),
    height: String(options.height),
  })
  const badgeUrl = new URL(`/tools/${tool.slug}/badge.svg`, siteConfig.url)
  badgeUrl.search = params.toString()

  return badgeUrl.toString()
}

export function getToolBadgeEmbedCode(
  tool: ToolBadgeEmbedTool,
  options: ToolBadgeEmbedOptions,
): string {
  const utm = new URLSearchParams({
    utm_source: siteConfig.slug,
    utm_medium: "badge",
    utm_campaign: "embed",
    utm_content: `tool-${tool.slug}`,
  })
  const toolUrl = new URL(`/tools/${tool.slug}`, siteConfig.url)
  toolUrl.search = utm.toString()
  const href = toolUrl.toString()
  const badgeUrl = getToolBadgeUrl(tool, options)
  const alt = escapeAttribute(`${tool.name} badge`)

  return `<a href="${href}" target="_blank" rel="${BADGE_REL}"><img src="${badgeUrl}" width="${options.width}" height="${options.height}" alt="${alt}" loading="lazy" /></a>`
}

function escapeAttribute(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll('"', "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
}
